<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import ContentSection from "@/components/Dashboard/Courses/allCourses/ContentSection.vue";
</script>

<template>
  <ContentHeader :name="'Courses'" />
  <ContentSection />
</template>
